import { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { getApiUrl } from '../../utils/api';

const KEY = 'caisse_import_job';
export const getCaisseImportJob = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; } };
export const setCaisseImportJob = (job) => localStorage.setItem(KEY, JSON.stringify({ ...job, started_at: Date.now() }));
export const clearCaisseImportJob = () => localStorage.removeItem(KEY);

/** Suit l'import de caisse en cours depuis n'importe quelle page : le serveur continue, on prévient quand c'est fini. */
export const ImportCaisseWatcher = () => {
  useEffect(() => {
    let timer; let misses = 0;
    const tick = async () => {
      const job = getCaisseImportJob();
      if (!job) { timer = setTimeout(tick, 4000); return; }
      if (Date.now() - (job.started_at || 0) > 3 * 3600 * 1000) { clearCaisseImportJob(); timer = setTimeout(tick, 4000); return; }
      try {
        const j = (await axios.get(`${getApiUrl()}/pos/import-pdf/${job.job_id}`, { withCredentials: true })).data;
        misses = 0;
        if (j.status === 'done') {
          clearCaisseImportJob();
          toast.success(`Caisse importée : ${j.jours_ecrits ?? 0} journée(s) · ${j.plats_reconnus ?? 0} plat(s) reconnus`, { description: job.filename, duration: 12000, id: `caisse-${job.job_id}` });
          window.dispatchEvent(new CustomEvent('caisse:imported', { detail: j }));
        } else if (j.status === 'error') {
          clearCaisseImportJob();
          toast.error(`Import de caisse échoué : ${j.error || 'lecture impossible'}`, { description: job.filename, duration: 15000, id: `caisse-${job.job_id}` });
        }
      } catch (e) {
        misses += 1;
        if (e?.response?.status === 404 || misses >= 30) { clearCaisseImportJob(); toast.error('Import de caisse perdu (serveur redémarré) : relancez l’envoi du PDF.', { id: `caisse-${job.job_id}` }); }
      }
      timer = setTimeout(tick, 4000);
    };
    tick();
    return () => clearTimeout(timer);
  }, []);
  return null;
};
